import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { Options } from '../modal.model';

@Component({
  selector: 'sb-custom-modal',
  templateUrl: './sb-custom-modal.component.html',
  styleUrls: ['./sb-custom-modal.component.scss'],
  standalone: false,
})
export class SbCustomModalComponent implements OnInit {
  options: Options<any>;
  @Input()
  templateId: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId);
  }

  constructor(private state: SbModalState) {}
}
